var React = require('react');

function HundredPolyclusterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M186.696 90.5366L156.892 105.576L158.769 72.2456L186.696 90.5366Z","stroke":"#C99CEF","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M50.0678 165.655L55.7308 174.035L45.6414 174.749L50.0678 165.655Z","stroke":"#C99CEF","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M17.5291 62.9105L3.98423 63.869L9.92659 51.6595L17.5291 62.9105Z","fill":"#C99CEF","key":2}),React.createElement("path",{"d":"M112.06 8.70258L132.095 13.2563L118.134 28.3299L112.06 8.70258Z","fill":"#B1F8FC","key":3})]);
}

HundredPolyclusterInline.defaultProps = {"width":"197","height":"182","viewBox":"0 0 197 182","fill":"none"};

module.exports = HundredPolyclusterInline;

HundredPolyclusterInline.default = HundredPolyclusterInline;
